// NONCE: 1 - Random comment counter for deploy. Increment to trigger a change for release.
import { provideZoneChangeDetection } from '@angular/core';
/// <reference types="@angular/localize" />
// noop: trigger app hosting rebuild

import * as Sentry from '@sentry/angular';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfigClient } from './app/app.config.client';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

Sentry.init({
  dsn: environment.sentryUrl,
  sendDefaultPii: true,
  environment: environment.env,
  release: environment.version,
  integrations: [Sentry.browserTracingIntegration()],
  ignoreErrors: [/Error retrieving icon.*Http failure response/],
  tracesSampleRate: environment.sentry.tracesSampleRate,
  tracePropagationTargets: [
    'localhost',
    /^https:\/\/app\.ripabet-staging\.com/,
    /^https:\/\/app\.ripabet\.com/,
    /^https:\/\/app\.gains\.com/,
  ],
  _experiments: { enableLogs: true },
});

bootstrapApplication(AppComponent, {
  ...appConfigClient,
  providers: [provideZoneChangeDetection(), ...appConfigClient.providers],
}).catch((err) => console.error(err));
